export {};
//# sourceMappingURL=internalTextureLoader.js.map